import { HomeScreenThemeModeConfig } from './types';

const dark: HomeScreenThemeModeConfig = {
  homeScreen: {
    backgroundColor: '#1a1a1a', // Dark background color
    backgroundGradient: 'linear-gradient(to top,rgb(150, 150, 150),rgb(226, 226, 226))', // Gradient for background
    textColor: '#111111', // White text color for contrast
    borderColor: '#444444', // Subtle border color
    hoverBackgroundColor: '#2a2a2a', // Background color on hover
    hoverTextColor: '#e0e0e0', // Text color on hover
  },
};

export default dark;
